// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: many of these constants have been duplicated in cssConstants.tsx */
/* Colours for Grid*/
/* Colours for Check statuses*/
/* Other colours */
/* black/grays/whites */
/* Colours for Data capture page*/
/* borders */
/* Dimensions*/
/* z-indexes */
/* Media queries */
/* Font Size */
/* Font Family */
/* Font Style */
.documentFieldDropdownlist.k-list-container .k-popup .k-list-scroller {
  max-height: 178px !important;
}
.documentFieldDropdownlist {
  padding: 0;
}
.fieldset .documentFieldTitle {
  font-size: 14px;
  line-height: 20px;
  font-weight: 700;
  opacity: 0.65;
}
@media (min-width: 786px) {
  .fieldset .documentFieldTitle {
    margin-left: 25px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/common/dataCapture/DocumentField.less"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E,oBAAoB;AACpB,8BAA8B;AAC9B,kBAAkB;AAClB,uBAAuB;AACvB,iCAAiC;AACjC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,kBAAkB;AAClB,cAAc;AACd,gBAAgB;AAChB,eAAe;AAVf;EACC,4BAAA;AAYD;AATA;EACC,UAAA;AAWD;AARA;EAEE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AASF;AANC;EAAA;IAEE,iBAAA;EAQD;AACF","sourcesContent":["@import '../../constants.less';\n\n.documentFieldDropdownlist.k-list-container .k-popup .k-list-scroller {\n\tmax-height: 178px !important; // must add important to override kendo css\n}\n\n.documentFieldDropdownlist {\n\tpadding: 0;\n}\n\n.fieldset {\n\t.documentFieldTitle {\n\t\tfont-size: 14px;\n\t\tline-height: 20px;\n\t\tfont-weight: @sofiaFontBold;\n\t\topacity: 0.65;\n\t}\n\n\t@media (min-width: @twoColumnFieldsPageMinWidth) {\n\t\t.documentFieldTitle {\n\t\t\tmargin-left: 25px;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
